<template>
  <div id="app" style="background-color: #F5F7FA;">
    <!-- <router-view /> -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import { addOrganizationSchema, addWebsiteSchema } from '@/utils/seo'

export default {
  name: 'App',
  mounted() {
    // SEO: 添加网站结构化数据
    addWebsiteSchema()
    addOrganizationSchema()
  }
}
</script>

<style lang="less">
@media (max-width: 768px) {
  html,
  body,
  #app {
    max-width: 100vw;
    overflow-x: hidden;
  }

  .course-special-page {
    width: 100%;
    max-width: 100vw;
    overflow-x: hidden;

    .hader {
      width: 100%;
      height: auto !important;
      min-height: 0 !important;
      padding-bottom: 20px;
      box-sizing: border-box;
      overflow: hidden;

      > img:first-child {
        position: static !important;
        display: block;
        width: 100% !important;
        height: auto !important;
        object-fit: cover;
      }

      > .bannder_text1,
      > .page-heading,
      > .pic,
      > .bannder_text2,
      > .bannder_btn {
        position: static !important;
        left: auto !important;
        top: auto !important;
        right: auto !important;
        bottom: auto !important;
        transform: none !important;
        width: calc(100% - 32px) !important;
        max-width: none;
        height: auto !important;
        margin: 14px 16px 0 !important;
        box-sizing: border-box;
        white-space: normal;
      }

      > .bannder_text1 {
        font-size: 15px !important;
        line-height: 1.5 !important;
      }

      > .page-heading {
        font-size: 26px !important;
        line-height: 1.25 !important;
      }

      > .pic {
        display: flex;
        flex-wrap: wrap;
        align-items: baseline;
        gap: 8px 16px;

        p {
          padding: 0;
          font-size: 14px !important;
          line-height: 1.5;
        }

        span {
          font-size: 20px !important;
        }
      }

      > .bannder_btn {
        display: flex;
        align-items: center;
        justify-content: center;
        max-width: 220px;
        min-height: 44px;
        padding: 10px 18px;
        font-size: 14px !important;
        line-height: 1.4 !important;
      }
    }

    .cont {
      width: 100% !important;
      max-width: 100vw;
      overflow-x: hidden;
    }

    .cnt_nav {
      width: 100% !important;
      min-height: 52px;
      height: auto !important;
      padding: 0 8px;
      box-sizing: border-box;
      display: flex !important;
      justify-content: flex-start !important;
      align-items: stretch;
      gap: 4px;
      overflow-x: auto;
      overflow-y: hidden;
      white-space: nowrap;
      -webkit-overflow-scrolling: touch;

      .nav_list {
        flex: 0 0 auto;
        width: auto !important;
        min-width: max-content;
        margin: 0 !important;
        padding: 0 10px;
        box-sizing: border-box;

        p {
          width: auto !important;
          min-width: max-content;
          margin: 0;
          white-space: nowrap;
          font-size: 14px !important;
          line-height: 52px !important;
        }

        span {
          left: 10px !important;
          right: 10px;
          width: auto !important;
        }
      }
    }

    .cont > [class^='cnt_box'],
    .cont > .con_pa3 {
      width: 100% !important;
      min-height: 0 !important;
      height: auto !important;
      padding: 32px 16px !important;
      box-sizing: border-box;
      overflow: hidden;
    }

    .cont > [class^='cnt_box'] > div,
    .cont > .con_pa3 > div,
    .cont > [class^='cnt_box'] > div > div,
    .cont > .con_pa3 > div > div {
      width: 100% !important;
      max-width: 100%;
      box-sizing: border-box;
      position: static !important;
      padding-left: 0 !important;
      padding-right: 0 !important;
      height: auto !important;
    }

    .cnt_box1 > h1,
    .cnt_box1 > h2,
    .cnt_box2 > h2,
    .cnt_box3 > h2,
    .title {
      width: 100% !important;
      height: auto !important;
      min-height: 0 !important;
      position: static !important;
      margin: 0 0 24px !important;
      text-align: left;

      span,
      p,
      h2 {
        position: static !important;
        display: block;
        width: auto !important;
        text-align: left;
        white-space: normal;
      }

      span {
        font-size: 15px !important;
      }

      p,
      h2 {
        margin-top: 8px;
        font-size: 22px !important;
        line-height: 1.35 !important;
      }

      img {
        width: 220px !important;
        max-width: 80%;
        height: auto !important;
        max-width: 100%;
      }
    }

    .cont h2 {
      left: auto !important;
      right: auto !important;
      transform: none !important;
      width: 100% !important;
      max-width: 100% !important;
      height: auto !important;
      min-height: 0 !important;
      position: static !important;
    }

    .cnt_box1tab {
      width: 100% !important;
      display: grid !important;
      grid-template-columns: 1fr;
      gap: 16px;
      margin: 0 !important;

      .box1tab_list {
        width: 100% !important;
        min-height: 120px;
        height: auto !important;
        margin: 0 !important;
        padding: 16px !important;
        box-sizing: border-box;

        > div {
          width: auto !important;
          min-width: 0;
          flex: 1;
        }
      }
    }

    .cnt_box2div,
    .cnt_box2tab {
      width: 100% !important;
      max-width: 100%;
      position: static !important;
      overflow-x: auto;
      overflow-y: hidden;
      -webkit-overflow-scrolling: touch;
    }

    .cnt_box2tab {
      > h2,
      > .box2tab_list {
        min-width: 680px;
      }

      > h2 {
        width: 680px !important;
        max-width: none !important;
      }
    }

    .cnt_box2 .xtbj,
    .cnt_box2div .xtbj {
      display: none !important;
    }

    .cnt_box2 ul,
    .cnt_box3 ul,
    .cnt_box4 ul,
    .cnt_box5 ul,
    .cnt_box6 ul {
      width: 100% !important;
      display: grid !important;
      grid-template-columns: 1fr;
      gap: 16px;
      margin: 0 !important;
      padding: 0 !important;
    }

    .cnt_box2 li,
    .cnt_box3 li,
    .cnt_box4 li,
    .cnt_box5 li,
    .cnt_box6 li {
      width: 100% !important;
      max-width: 100%;
      min-height: 0 !important;
      height: auto !important;
      margin: 0 !important;
      box-sizing: border-box;
      float: none !important;
      min-width: 0 !important;
    }

    .cnt_box2 li > *,
    .cnt_box3 li > *,
    .cnt_box4 li > *,
    .cnt_box5 li > *,
    .cnt_box6 li > * {
      min-width: 0;
      max-width: 100% !important;
      box-sizing: border-box;
    }

    .cnt_box3 li {
      display: block !important;

      .text,
      .img {
        display: block !important;
        width: 100% !important;
        min-width: 0;
        height: auto !important;
        padding: 12px 0 !important;
      }
    }

    .cnt_box2 li img,
    .cnt_box3 li img,
    .cnt_box4 li img,
    .cnt_box5 li img,
    .cnt_box6 li img {
      max-width: 100% !important;
      height: auto !important;
    }

    .cnt_box4 .pc_ti {
      width: 100% !important;
      height: auto !important;
      display: grid !important;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 12px;
      overflow: hidden;
    }

    .cnt_box4 .pc_ti img {
      position: static !important;
      width: 100% !important;
      height: auto !important;
      max-width: 100%;
    }

    .cnt_box4 .cnt_img1,
    .cnt_box4 .cnt_img2 {
      display: none !important;
    }

    .con_pa3box {
      display: block !important;

      > img,
      .con_pa3listbox,
      .con_pa3list {
        width: 100% !important;
        max-width: 100%;
        height: auto !important;
        box-sizing: border-box;
      }

      > img {
        margin-bottom: 16px;
      }
    }

    .cnt_box5 > .img {
      display: block;
      width: 100% !important;
      max-width: 100%;
      height: auto !important;
    }

    .cnt_box5 .fl,
    .cnt_box5 .fr,
    .cnt_box1 .fl,
    .cnt_box1 .fr,
    .cnt_box3 .fl,
    .cnt_box3 .fr {
      float: none !important;
      width: 100% !important;
      max-width: 100%;
      box-sizing: border-box;
    }

    .cnt_box1 li {
      display: block !important;
    }

    .cnt_box6 .ren_zheng {
      display: none !important;
    }

    .cnt_box5 span {
      position: static !important;
      display: block;
      padding: 8px 0;
      text-align: center;
      white-space: normal;
    }

    .codeDialog {
      width: calc(100vw - 32px) !important;
      max-width: 320px;
      height: auto !important;
      box-sizing: border-box;

      img {
        width: 240px !important;
        max-width: 100%;
        height: auto !important;
      }
    }
  }
}
</style>
